import { render, staticRenderFns } from "./editDescriptionsOnActivityType.vue?vue&type=template&id=57a699b2&scoped=true&"
import script from "./editDescriptionsOnActivityType.vue?vue&type=script&lang=js&"
export * from "./editDescriptionsOnActivityType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a699b2",
  null
  
)

export default component.exports